import * as Form from '../../components/form'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

export const confirmForgotPasswordSubmit: Types.ResetPasswordSubmit =
  (fields: Types.FormFields) => {
    return Request.requestActionCreator<any>(Constants.CONFIRM_FORGOT_PASSWORD)({
      method: 'POST',
      payload: fields,
      url: `${Constants.SERVER_RESOURCE}/confirm-forgot-password`,
    })
  }

export const firstLoginSubmit: Types.ResetPasswordSubmit =
  (fields: Types.FormFields) => {
    return Request.requestActionCreator<any>(Constants.FIRST_LOGIN)({
      method: 'POST',
      payload: fields,
      url: `${Constants.SERVER_RESOURCE}/first-login`,
    })
  }

export const checkAlreadyConfirmedUser: Types.CheckAlreadyConfirmedUserSubmit =
  (fields: Types.CheckAlreadyConfirmedUserFields) => {
  return Request.requestActionCreator<any>(Constants.ALREADY_CONFIRMED_USER)({
    method: 'POST',
    payload: fields,
    url: `${Constants.SERVER_RESOURCE}/check-already-confirmed-user`,
  })
}

export const FormActions = Form.createActionsMap(Constants.UPDATE_RESET_PASSWORD_FIELD)
export const FormConstants = Form.createConstantsMap(Constants.UPDATE_RESET_PASSWORD_FIELD)



// WEBPACK FOOTER //
// ./src/pages/reset-password/actions.ts